import { reactive } from "vue";

export default {
  install(app) {
    const deviceState = reactive({
      isMobile: window.innerWidth <= 768,
    });

    const detectMobile = () => {
      deviceState.isMobile = window.innerWidth <= 768;
    };

    window.addEventListener("resize", detectMobile);

    app.config.globalProperties.$device = deviceState;

    app.mixin({
      beforeUnmount() {
        window.removeEventListener("resize", detectMobile);
      },
    });
  },
};
